import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BOOKING_URL = "https://calendar.app.google/jQc3fcfKnpaJqFFn6";
export const AGENCY_EMAIL = "pat@icpmatters.com";

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};
